import { render } from "./scrollIndicator.vue?vue&type=template&id=05d489b2&scoped=true"
import script from "./scrollIndicator.vue?vue&type=script&lang=js"
export * from "./scrollIndicator.vue?vue&type=script&lang=js"

import "./scrollIndicator.vue?vue&type=style&index=0&id=05d489b2&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d489b2"]])

export default __exports__